import NewsTile from "./NewsTile";
import { NewsTileContainerInterface } from "./types";

const ComponentContainer: React.FC<NewsTileContainerInterface> = (props) => {
  return <NewsTile {...props} />;
};

export default ComponentContainer;
